import styled from 'styled-components';

export const VitalSidebarSC = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 24px;
`;

export const SectionTitleSC = styled.h3`
  opacity: 0.6;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.25;
  margin-bottom: 16px;
`;
